"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var BellFill = function BellFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "BellFill"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "bell-fill"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.5 15h-10.82c-0 0-0 0-0.001 0-1.005 0-1.82-0.815-1.82-1.82 0-0.608 0.298-1.146 0.755-1.476l0.005-0.004c0.573-0.386 0.947-1.028 0.96-1.758l0-0.002v-2.32c0.175-2.751 2.45-4.916 5.23-4.916s5.055 2.165 5.229 4.901l0.001 0.015v2.26c0 0.001 0 0.003 0 0.004 0 0.746 0.378 1.403 0.952 1.791l0.008 0.005 0.44 0.3c0.457 0.296 0.755 0.804 0.755 1.381 0 0.906-0.734 1.64-1.64 1.64-0.019 0-0.039-0-0.058-0.001l0.003 0zM7.18 15.72c0.351 1.112 1.373 1.904 2.58 1.904s2.229-0.792 2.575-1.885l0.005-0.019z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = BellFill;
exports["default"] = _default;